module.exports = __webpack_public_path__ + "static/media/printing-services-img16.8eb60acc.jpg";